/* eslint-disable jsx-a11y/alt-text */
import { faShareFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function CompleteProfileStep({ user, handleResumeUploadModal, onShare }) {
  const [completedSteps, setCompletedSteps] = useState(0);
  const [completeWarningText, setCompleteWarningText] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    userProfileUpdateWarningText(user);
    userProfileUpdatePercent(user);
  }, [user]);

  const userProfileUpdateWarningText = (user) => {
    if (
      user?.user_details &&
      user?.user_details?.user_meta_info &&
      user?.user_details?.user_meta_info?.resume === null
    ) {
      setCompleteWarningText("resume.");
    } else if (
      Array.isArray(user?.skills) &&
      user?.skills &&
      user.skills.length === 0
    ) {
      setCompleteWarningText("skills.");
    } else if (
      user?.work_experience &&
      Array.isArray(user?.work_experience) &&
      user.work_experience.length === 0
    ) {
      setCompleteWarningText("professional experience.");
    } else if (
      user?.candidate_website === null &&
      user?.linkedin_url === null &&
      user?.github_url === null
    ) {
      setCompleteWarningText("github or linkedin url.");
    }
  };

  const userProfileUpdatePercent = (user) => {
    let count = 1;
    // profession, resume, skill, candidate phone, websites
    if (
      user?.user_details &&
      user?.user_details?.user_meta_info &&
      user?.user_details?.user_meta_info?.resume !== null
    ) {
      count = count + 1;
    }
    if (
      Array.isArray(user?.skills) &&
      user?.skills &&
      user.skills.length > 0
    ) {
      count = count + 1;
    }
    if (
      user?.work_experience &&
      Array.isArray(user?.work_experience) &&
      user.work_experience.length > 0
    ) {
      count = count + 1;
    }
    if (
      user?.candidate_website != null ||
      user?.linkedin_url != null ||
      user?.github_url != null
    ) {
      count = count + 1;
    }

    setCompletedSteps(count);
  };

  const onCompleteProfileClick = () => {
    if (user?.user_details && user.user_details?.role === "mentor") {
      navigate("/edit-mentor-profile");
    } else {
      navigate("/edit-candidate-profile");
    }
  };

  return (
    <div className="rounded-lg p-2 d-flex bg-white mb-4 bg-grey">
      <div className="w-100">
        {completedSteps < 5 ? (
          <h5 className="mb-3 d-flex justify-content-between align-items-start font-weight-normal">
            <span className="mr-2">
              Increase your chance by filling missing information recruiters typically look for.
              {" "}
              <span className="">{completeWarningText}</span>
            </span>
            <FontAwesomeIcon icon={faShareFromSquare} className="text-primary cursor-pointer" onClick={onShare} />

          </h5>) : (
          <h5 className="d-flex align-items-start justify-content-between mb-3 font-weight-400">
            <span className="mr-3">Looking good! You completed all the profile details.</span>
            <FontAwesomeIcon icon={faShareFromSquare} className="text-primary cursor-pointer" onClick={onShare} />
          </h5>
        )}

        <h5 className="text-primary font-weight-bold">
          {completedSteps * 20}% Profile Completed
        </h5>
        <div>
          <ul className="d-flex evaluation-ratings align-items-center mt-1">
            {completedSteps
              ? [...Array(completedSteps).keys()].map(() => (
                <li
                  className="bg-primary mr-2 rounded-lg"
                  style={{ width: "20%", height: "5px" }}
                >
                  <span
                    className="d-inline-block bg-primary"
                    style={{ width: "100%" }}
                  ></span>
                </li>
              ))
              : null}
            {[...Array(5 - completedSteps).keys()].map((i) => (
              <li
                className="bg-light mr-2 rounded-lg"
                style={{ width: "20%", height: "5px" }}
              >
                <span
                  className="d-inline-block bg-primary"
                  style={{ width: "0%" }}
                ></span>
              </li>
            ))}
          </ul>
          <div className="font-weight-medium mt-2">
            <div className="d-flex align-items-center">
              {user?.user_details &&
                user?.user_details?.user_meta_info &&
                user?.user_details?.user_meta_info?.resume === null ? (
                <>
                  <h6 className="text-danger cursor-pointer d-flex justify-content-between mb-0 mt-2">
                    <p className="mr-2">Please upload your resume</p>
                    <span
                      className="text-primary ml-auto"
                      onClick={() => handleResumeUploadModal(true)}
                    >
                      Upload Now
                    </span>
                  </h6>
                </>
              ) : (
                <>
                  {completedSteps < 5 && (
                    <h5
                      className="text-primary cursor-pointer mt-2 text-nowrap ml-auto mr-2"
                      onClick={() => onCompleteProfileClick()}
                    >
                      Update Profile
                    </h5>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompleteProfileStep;
